import { Button, Collapse, Form, Input } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { FC, Fragment, useState } from 'react';
import CCASiteVisitReportAttendee from './VisitReportVerificationPage.Site.Attendee';
import CCASiteVisitReportDetail, {
	useCCASiteVisitReportDetailForm,
} from './VisitReportVerificationPage.Site.Detail';
import CCASiteVisitReportUnit from './VisitReportVerificationPage.Site.Unit';
import CCASiteVisitReportActivity from './VisitReportVerificationPage.Site.Activity';
import FleetTitle from '@/libs/antd/components/Title';
import rule from '@/libs/antd/rules';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import CCASiteVisitReportPhoto from './VisitReportVerificationPage.Site.Photo';
import { useMutation } from '@tanstack/react-query';
import { submitCCASiteReportDetail } from '@/libs/fleet-api/services/visit-reports';
import { SiteReport } from '@/libs/fleet-api/services/types';
import { useApp } from '@/App';

const CCAVisitReportVerificationSite: FC<{ onNext: () => void }> = ({
	onNext,
}) => {
	const { notification } = useApp();
	const detailForm = useCCASiteVisitReportDetailForm();
	const submitCCASiteReportDetailMutation = useMutation({
		mutationFn: submitCCASiteReportDetail,
	});

	const [activeKey, setActiveKey] = useState<string[]>([]);
	const [checkedItems, setCheckedItems] = useState<string[]>([]);

	const renderCheck = (key: string) => {
		return (
			<span
				style={{
					fontSize: 24,
					lineHeight: 1,
					color: checkedItems.includes(key) ? '#39A905' : '#9A9A9A',
				}}
			>
				<CheckCircleFilled />
			</span>
		);
	};

	const handleChecked = (key: string) => {
		setCheckedItems((checked) => [...checked, key]);
		setActiveKey((keys) => keys.filter((f) => f !== key));
	};

	const isAllowSubmitting =
		checkedItems.includes('visit') &&
		checkedItems.includes('unit') &&
		checkedItems.includes('activity');

	return (
		<Form.Provider
			onFormFinish={async (name, { values }) => {
				if (!name) return;
				try {
					await submitCCASiteReportDetailMutation.mutateAsync(
						values as SiteReport<'payload'>,
					);
					handleChecked('visit');
				} catch {
					notification.error({
						message: 'Failed',
						description: 'Failed submit visit detail',
					});
				}
			}}
		>
			<Collapse
				activeKey={activeKey}
				onChange={(keys) => setActiveKey(keys as string[])}
				items={[
					{
						key: 'visit',
						label: 'Detail Kunjungan',
						extra: renderCheck('visit'),
						children: (
							<Fragment>
								<CCASiteVisitReportAttendee />
								<CCASiteVisitReportDetail {...detailForm} />
							</Fragment>
						),
					},
					{
						key: 'unit',
						label: 'Analisa Unit',
						collapsible: !checkedItems.includes('visit')
							? 'disabled'
							: undefined,
						extra: renderCheck('unit'),
						children: (
							<CCASiteVisitReportUnit
								onSave={() => {
									handleChecked('unit');
								}}
							/>
						),
					},
					{
						key: 'activity',
						label: 'Aktivitas Usaha',
						collapsible: !checkedItems.includes('unit')
							? 'disabled'
							: undefined,
						extra: renderCheck('activity'),
						children: (
							<CCASiteVisitReportActivity
								onSave={() => {
									handleChecked('activity');
								}}
							/>
						),
					},
				]}
				style={{
					marginBottom: 20,
				}}
			/>

			<FleetTitle>Action Plan</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				name="siteReport"
				form={detailForm.form}
				style={{ marginBottom: 20 }}
			>
				<Form.Item
					name={detailForm.fieldName('actionPlan')}
					rules={[rule.required()]}
				>
					<Input.TextArea
						rows={4}
						disabled
					/>
				</Form.Item>
			</Form>

			<CCASiteVisitReportPhoto />

			<Button
				type="primary"
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 20,
				}}
				disabled={!isAllowSubmitting}
				onClick={() => {
					detailForm.form.submit();
					onNext?.();
				}}
			>
				NEXT
			</Button>
		</Form.Provider>
	);
};

export default CCAVisitReportVerificationSite;
